export default "__VITE_ASSET__BnbNOjA5__ 480w, __VITE_ASSET__iCtcvLeQ__ 768w, __VITE_ASSET__DLR8u4Ex__ 1200w, __VITE_ASSET__BAkaHPFC__ 1280w";